import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { bookingsSelectors } from '~/api';
import { TotalPriceDetails } from '../../../../components';

export const mapStateToProps = createStructuredSelector({
  totalPrice: bookingsSelectors.selectTotalPrice,
  isAppointmentGift: bookingsSelectors.selectIsGiftAnswer,
});

export const ConnectedTotalPriceDetails = connect(mapStateToProps)(TotalPriceDetails);
